__turbopack_context__.v({
  "scrollUpButton": "ScrollToTop-module__Yno3Lq__scrollUpButton",
  "scrollUpDefault": "ScrollToTop-module__Yno3Lq__scrollUpDefault",
  "scrollUpSupport": "ScrollToTop-module__Yno3Lq__scrollUpSupport",
  "visible": "ScrollToTop-module__Yno3Lq__visible",
});
